import _ from 'lodash';
import Vue from 'vue';

import DashboardWidget from '../../../modules/dashboards/components/dashboard-widget/dashboard-widget.component';
import DashboardMulticriteria from '../../../modules/dashboards/components/dashboard-multicriteria/dashboard-multicriteria.component';

import KendoChart from '../../core/charts/KendoChart';
import infoBoard from '../../core/infoboard';
import streetView from '../../core/map/streetview';
import templates from '../../core/templates';
import translate from '../../core/tools/translate';
import { customScrollbar } from '../../shared';
import { hidePanelSelectionAlert } from '../../../utils';
import api from '../../api';
import { FeaturePermission } from '../../../constants/feature.permission.helper';
import environment from '../../environment';
import { MulticriteriaTypesMap } from '../../../enuns/AfterSales/multicriteriaTypes.enum';
import { Network } from '../../../enuns/AfterSales/network';
import worldMap from '../../core/map';
import { notify, NOTIFY_TYPE } from '../../shared/notify';
import { selectMarker } from '../../shared/map';
import dialog from '../../core/dialog';
import databoard from '../../core/databoard';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const LayerControls = name => require('../../controls').get(name);
const currentLayer = name => LayerControls(name).getLayer();
const GetLayer = (name, currentMap = worldMap.getCurrent()) => {
    return require('../../layers/index').default.get(name, currentMap);
};

const _getContainer = (visible = false) =>
    infoBoard.createContainer({
        id: 'info',
        name: 'Profile',
        visible
    });

const showStreeView = (latlng, autostart = false) => {
    streetView.visible(false);
    streetView.show(latlng, true, autostart);
};

const multicriteriaTypes = [
    {
        value: 1,
        name: translate(`Common.${MulticriteriaTypesMap.autoParts}`),
        visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreAutoparts)
    },
    {
        value: 2,
        name: translate(`Common.${MulticriteriaTypesMap.tireRetail}`),
        visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreTireRetail)
    },
    {
        value: 3,
        name: translate(`Common.${MulticriteriaTypesMap.tireTruck}`),
        visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreTireTruck)
    }
];

const _enlargeImage = (images, latlng, el) =>
    $(el).on('click', e => {
        e.preventDefault();

        const $template = $(templates('stores-image', images));
        const $content = $('#image-container');
        if ($content.is(':visible')) {
            $content.find('.cancel').trigger('click');
        }

        $content.fadeIn(300);
        $content.html($template);

        $template.find('.cancel').on('click', () => $content.empty().hide());

        showStreeView(latlng);
    });

const _drawChart = chart => setTimeout(() => new KendoChart(chart.container, chart.data, chart.options), 300);

const _generateSalesChart = (data, container) => {
    const chart = {
        container,
        data: {
            data: data.sales.chart,
            type: 'area',
            simple: true,
            label: false,
            colors: ['#D1D5D8', '#3498DB'],
            opacity: 0.75,
            currency: true
        },
        options: {
            title: '',
            filename: `${data.name} - ${translate('Common.AverageMonthlySales')}`,
            convertTable: true,
            autoheight: true,
            autocoloring: false,
            scrollable: false,
            height: 140,
            buttons: {
                // table: true,
                export: true
            }
        }
    };

    return _drawChart(chart);
};

const _generateSalesBySegments = (data, container) => {
    data.salesBySegments._tables[0].columns = data.salesBySegments._tables[0].columns.reverse();
    const chart = {
        container,
        data: {
            data: data.salesBySegments,
            type: 'bar',
            simple: true,
            label: true,
            opacity: 0.75,
            legend: {
                position: 'bottom',
                visible: true,
                align: 'left',
                orientation: 'vertical'
            }
        },
        options: {
            title: translate('Common.TotalSalesBySegments'),
            filename: `${data.name} - ${translate('Common.TotalSalesBySegments')}`,
            convertTable: true,
            height:
                data.salesBySegments.getTotalRows() * 13 * data.salesBySegments.getTotalColumns() +
                16 * data.salesBySegments.getTotalRows()
        }
    };

    return _drawChart(chart);
};

const _generateIndicatorsGrid = (data, container) => {
    const el = document.createElement('div');
    $(container).html(el);

    return new Vue({
        el,
        components: {
            dashboardWidget: DashboardWidget
        },
        data: {
            title: translate('Common.TypesOfServiceAfterSales'),
            filename: `${data.name} - ${translate('Common.TypesOfServiceAfterSales')}`,
            grid: data.services.grid,
            height: 30 + data.services.grid.length * 96,
            buttons: {
                export: true
            }
        },
        template: `
            <dashboard-widget
                :title="title"
                :filename="filename"
                :buttons="buttons"
                :height="height"
                :grid="grid"/>
            </dashboard-widget>
        `
    });
};

const _generateSalesPerSegmentGrid = (data, container) => {
    const el = document.createElement('div');
    $(container).html(el);

    return new Vue({
        el,
        components: {
            dashboardWidget: DashboardWidget
        },
        data: {
            title: translate('Common.RetailSales'),
            filename: `${data.name} - ${translate('Common.TotalSales')}`,
            grid: data.sales.grid,
            buttons: {
                export: true
            }
        },
        template: `
            <dashboard-widget
                :title="title"
                :filename="filename"
                :buttons="buttons"
                :grid="grid"/>
            </dashboard-widget>
        `
    });
};

const _prepareBoardInfluenceAreaNetwork = (store, $content) => {
    $content.on('click', '.store-info-tab', e => {
        e.preventDefault();

        const $tab = $(e.currentTarget);
        const tab = $tab.data('tab');

        $content.find('.store-info-tab').removeClass('is-active').attr('aria-selected', 'false');

        $tab.addClass('is-active').attr('aria-selected', 'true');

        if (tab === 'ficha') {
            $content.find('.store-tab-content--ficha').show();
            $content.find('.store-tab-content--influence').hide();
        } else if (tab === 'influence') {
            $content.find('.store-tab-content--ficha').hide();
            $content.find('.store-tab-content--influence').show();
        }

        const groupContent = $content.find('.panel-group-content');
        customScrollbar(groupContent);
    });

    const $storeInfluenceCard = $content.find('.store-influence-card');
    const $btnGenerateArea = $content.find('.store-influence-btn-edit');
    const $btnRemoveInfluenceArea = $storeInfluenceCard.find('.store-influence-btn-delete').hide();

    const checkStore = _checkStoreHasInfluenceActive(store, $content);

    $btnGenerateArea.on('click', e => {
        _generateInfluenceAreaNetwork(store, $storeInfluenceCard);
    });

    $btnRemoveInfluenceArea.on('click', e => {
        _removeInfluenceAreaNetwork(store, $storeInfluenceCard);
    });
};

const _generateInfluenceAreaNetwork = (
    featureNetwork,
    content,
    currentMap = worldMap.getCurrent(),
    name = 'NetworkAfterSales'
) => {
    const control = LayerControls('ServiceAreaAfterSales');
    const controlOptions = control._getServiceAreaOptions();
    const drawn = control.hasServiceAreaForStore(featureNetwork.id);

    if (drawn.hasAny) {
        controlOptions.showRadiusReal = drawn.hasReal;
        controlOptions.showRadiusTheoretical = drawn.hasTheoretical;

        const customStyle = control.getStoreCustomStyle(featureNetwork.id);
        if (customStyle) {
            controlOptions.color = customStyle.color;
            controlOptions.opacity = customStyle.opacity;
            controlOptions.weight = customStyle.weight;
        }
    }

    dialog.serviceAreaStyle('serviceArea', {
        options: controlOptions,
        change: (e, onClose) => {
            control.removeStore(featureNetwork.id);
            control.loadForStore(featureNetwork.id, e);
            control.check(true, false);

            content.find('.store-influence-btn-edit').text('Editar');
            content.find('.store-influence-btn-delete').show();

            const nameTypeArea = (e.showRadiusReal && e.showRadiusTheoretical) ? 'Área Real + Área Potencial'
                : e.showRadiusReal ? 'Área Real' : 'Área Potencial';
            content.find('.store-influence-subtitle').text(nameTypeArea);

            const feature = { properties: { Id: featureNetwork.id, Name: featureNetwork.name } };
            LayerControls(name).createDashboardServiceArea(feature, {
                hasReal: e.showRadiusReal,
                hasTheoretical: e.showRadiusTheoretical,
                hasAny: e.showRadiusReal || e.showRadiusTheoretical
            });

            onClose();
        },
        onStyle: () => {
        },
        onDelete: (onClose) => {
            control.removeStore(featureNetwork.id);

            databoard.reset();
            databoard.hide();
            onClose();
            content.find('.store-influence-btn-edit').text('Gerar');
            content.find('.store-influence-btn-delete').hide();
            content.find('.store-influence-subtitle').text('A definir');
        }
    });
};

const _removeInfluenceAreaNetwork = (featureNetwork, content) => {
    try {
        LayerControls('ServiceAreaAfterSales').removeStore(featureNetwork.id);
    } catch (err) {}

    content.find('.store-influence-btn-edit').text('Gerar');
    content.find('.store-influence-btn-delete').hide();
    content.find('.store-influence-subtitle').text('A definir');
    databoard.reset();
    databoard.hide();
};

const _checkStoreHasInfluenceActive = (store, content) => {
    try {
        const check = LayerControls('ServiceAreaAfterSales').hasServiceAreaForStore(store.id);

        if (check.hasAny) {
            content.find('.store-influence-btn-edit').text('Editar');
            content.find('.store-influence-btn-delete').show();
            const nameTypeArea = (check.hasReal && check.hasTheoretical) ? 'Área Real + Área Potencial'
                : check.hasReal ? 'Área Real' : 'Área Potencial';
            content.find('.store-influence-subtitle').text(nameTypeArea);
        }
    } catch (err) {}

    return false;
};

const _generateSalesGrid = (data, container) => {
    const el = document.createElement('div');
    $(container).html(el);

    return new Vue({
        el,
        components: {
            dashboardWidget: DashboardWidget
        },
        data: {
            title: data.title,
            filename: `${data.name} - ${translate('Common.TotalSales')}`,
            grid: data.sales.grid,
            tooltip: true,
            buttons: {
                export: true
            },
            height: 135
        },
        template: `
            <dashboard-widget
                :title="title"
                :filename="filename"
                :buttons="buttons"
                :height="height"
                :tooltip="tooltip"
                :grid="grid"/>
            </dashboard-widget>
        `
    });
};

const _buildMulticriteriaTable = (data, title, exportFileName, container) => {
    const el = document.createElement('div');
    $(container).append(el);

    return new Vue({
        el,
        components: {
            dashboardMulticriteria: DashboardMulticriteria
        },
        data: {
            title: title,
            filename: `${environment.get('CONFIG.CLIENT')}_Multicriterio`,
            grid: data,
            tooltip: true,
            id: data ? data[0].data.dataSource[0].multicriteriaId : 0,
            multicriteriaTypes,
            buttons: {
                export: (filename, type) => {
                    const selectedType = multicriteriaTypes.find(x => x.value === Number(type));
                    const optionName = selectedType ? selectedType.name : type;
                    api.afterSales.get.multicriteria.exportXls(
                        [data[0].data.dataSource[0].multicriteriaId],
                        type,
                        `${filename}_${optionName}_${exportFileName}.xlsx`
                    );
                }
            }
        },
        template: `
            <dashboard-multicriteria
                :title="title"
                :id="id"
                :filename="filename"
                :buttons="buttons"
                :tooltip="tooltip"
                :grid="grid"
                :multicriteriaTypes="multicriteriaTypes"
                @export="(filename, type) => buttons.export ? buttons.export(filename, type) : undefined"/>
            </dashboard-multicriteria>
        `
    });
};

class ResumeAfterSalesInfo {
    static getInstance() {
        if (!ResumeAfterSalesInfo._instance) {
            ResumeAfterSalesInfo._instance = new ResumeAfterSalesInfo();
        }

        return ResumeAfterSalesInfo._instance;
    }

    init() {}

    _getFeatureLayer(resultType, feature) {
        return currentLayer(resultType).getLayer(feature.properties.Id);
    }

    show(store, options = {}) {
        const $container = _getContainer(options ? options.visible : false);
        if (store.properties.NetworkId === Network.Distributor) {
            store.hasInfluenceArea = true;
        }

        const $content = $(templates('stores-view-after-sales', { ...store, title: options.title }));
        $($container).html($content);

        infoBoard.open();
        if (store.hasInfluenceArea) {
            _prepareBoardInfluenceAreaNetwork(store, $content);
        }

        const coordinates = {
            lat: store.location.latitude,
            lng: store.location.longitude
        };

        if (store.image) {
            if (store.image.hasPhoto) {
                const imageLink = $content.find('.store-thumbnail-link');
                _enlargeImage(store.image, coordinates, imageLink);
            } else {
                const imageContainer = $content.find('.store-thumbnail');
                streetView.thumbnail(imageContainer, coordinates);
            }
        }

        setTimeout(() => {
            let chartContainer;

            if ((store.scoreCalculated || {}).tables) {
                chartContainer = $content.find('.chart-multicriteria')[0];
                const grid = _(store.scoreCalculated.tables)
                    .keys()
                    .map(theme => ({
                        data: store.scoreCalculated.tables[theme],
                        theme
                    }))
                    .value();

                _buildMulticriteriaTable(
                    grid,
                    translate('Common.MulticriteriaAfterSales'),
                    `${store.name}`,
                    chartContainer
                );
            }

            if ((store.services || {}).grid) {
                chartContainer = $content.find('.chart-services')[0];
                _generateIndicatorsGrid(store, chartContainer);
            }

            if ((store.sales || {}).chart) {
                chartContainer = $content.find('.chart-sales')[0];
                _generateSalesChart(store, chartContainer);
            }

            if (_.size(store.salesBySegments)) {
                chartContainer = $content.find('.chart-sales-by-segment')[0];
                _generateSalesBySegments(store, chartContainer);
            }

            if ((store.sales || {}).grid) {
                let title = `${translate('Common.Sales')} (R$)`;
                chartContainer = $content.find('.table-sales')[0];
                _generateSalesGrid({ ...store, title }, chartContainer);
            }

            if ((store.sales || {}).gridVehicles) {
                let title = `${translate('Common.Sale')} ${translate('Common.Items')} (und)`;

                const dataGrid = {
                    ...store,
                    title: title,
                    sales: {
                        grid: store.sales.gridVehicles
                    }
                };
                chartContainer = $content.find('.table-sales-vehicles')[0];
                _generateSalesGrid(dataGrid, chartContainer);
            }

            if ((store.salesPerSegment || {}).grid) {
                chartContainer = $content.find('.table-sales-segment')[0];
                _generateSalesPerSegmentGrid(store, chartContainer);
            }
        }, 1000);

        if (options.callback) {
            if (store.report) {
                $content.find('#store-action-report').on('click', e => {
                    e.preventDefault();
                    options.callback('reporting');
                });
            }
        }

        $content.find('.store-info-back-button').on('click', e => {
            e.preventDefault();
            hidePanelSelectionAlert();
            options.callbackBack();
        });

        const groupContent = $content.find('.panel-group-content');
        customScrollbar(groupContent);
    }

    remove() {
        const container = _getContainer();
        infoBoard.dataUnavailable({
            container,
            message: translate('Error.LayerDisabled'),
            image: 'no_data'
        });
        streetView.hide();
    }

    updateBoardInfluenceArea(store) {
        const $content = $(".store-influence-card-header");
        store.properties.id = store.properties.Id;

        try {
            const check = LayerControls('ServiceAreaAfterSales').hasServiceAreaForStore(store.properties.Id);
            if (check.hasAny) {
                return _checkStoreHasInfluenceActive(store.properties, $content);
            }
        } catch (err) {}

        _removeInfluenceAreaNetwork(store.properties, $content);
    }
}

export default ResumeAfterSalesInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/AfterSales/ResumeAfterSalesInfo.js